export default __webpack_public_path__ + "static/media/slide_cursos.be090278.png";